import React from 'react';
import PropTypes from 'prop-types';
import AppToolbarContainer from 'components/Toolbar/v2/AppToolbarContainer';
import ToolbarPropTypes from 'components/Toolbar/v2/ToolbarPropTypes';
import PLGNavbar from 'components/Lite/PLGNavbar';
import Banner from 'components/Toolbar/v2/Banner';
import BrowserRouter from './Routing/BrowserRouter';

import BasicNavbarWithBackButton, { shouldRenderBasicNavbar } from './BasicNavbarWithBackButton';
import { MyMoneyNotificationsCountProvider } from 'components/MyMoneyV2/context/MyMoneyNotificationsCountContext';
import { NavbarProvider } from 'components/Common/Navigation/NavbarProvider';

const PageWithToolbar = ({ toolbarProps, hideNoticeBar, toolbarActions, legacyToolbar, children }) => {
  if (shouldRenderBasicNavbar(toolbarProps)) {
    return (
      <NavbarProvider>
        <BasicNavbarWithBackButton toolbarActions={toolbarActions} theProps={toolbarProps} />
        {children}
      </NavbarProvider>
    );
  }

  if (toolbarProps.productLeadGrowthPath) {
    return (
      <MyMoneyNotificationsCountProvider
        openDisputesCount={toolbarProps.openDisputesCount}
        consumerFinancingNotificationsCount={toolbarProps.consumerFinancingNotificationsCount}
      >
        <NavbarProvider>
          <PLGNavbar banner={hideNoticeBar ? null : <Banner noticeBar={toolbarProps.noticeBar} />} />
          {children}
        </NavbarProvider>
      </MyMoneyNotificationsCountProvider>
    );
  }

  return (
    <MyMoneyNotificationsCountProvider
      openDisputesCount={toolbarProps.openDisputesCount}
      consumerFinancingNotificationsCount={toolbarProps.consumerFinancingNotificationsCount}
    >
      <NavbarProvider>
        <AppToolbarContainer
          theProps={toolbarProps}
          hideNoticeBar={hideNoticeBar}
          toolbarActions={toolbarActions}
          legacyToolbar={legacyToolbar}
        />
        {children}
      </NavbarProvider>
    </MyMoneyNotificationsCountProvider>
  );
};

PageWithToolbar.propTypes = {
  toolbarProps: ToolbarPropTypes,
  hideNoticeBar: PropTypes.bool,
  children: PropTypes.node,
  toolbarActions: PropTypes.node,
  legacyToolbar: PropTypes.bool,
};

PageWithToolbar.defaultProps = {
  legacyToolbar: false,
};

export default PageWithToolbar;
